"use strict";

var __assign = this && this.__assign || Object.assign || function (t) {
  for (var s, i = 1, n = arguments.length; i < n; i++) {
    s = arguments[i];

    for (var p in s) {
      if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
    }
  }

  return t;
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var scales_1 = require("../constants/scales");

var palette_1 = require("../constants/palette");

var directionalPropsToStylesUtil_1 = require("../utils/directionalPropsToStylesUtil");

var propToStyleMap = {
  ba: 'border',
  bt: 'border-top',
  br: 'border-right',
  bb: 'border-bottom',
  bl: 'border-left',
  bx: ['border-right', 'border-left'],
  by: ['border-top', 'border-bottom']
};

var border = function border(props) {
  if (props === void 0) {
    props = {};
  }

  var borderColor = props.borderColor ? props.borderColor : palette_1.default.lightGrey;

  var styles = __assign({}, directionalPropsToStylesUtil_1.default(props, propToStyleMap, scales_1.borderScale, "solid " + borderColor));

  if (props.borderRound) {
    styles['border-radius'] = '4px';
  }

  return styles;
};

exports.default = border;